import { render, staticRenderFns } from "./NewTaxRollUploadToBackend.vue?vue&type=template&id=207cd685&scoped=true&"
import script from "./NewTaxRollUploadToBackend.vue?vue&type=script&lang=js&"
export * from "./NewTaxRollUploadToBackend.vue?vue&type=script&lang=js&"
import style0 from "./NewTaxRollUploadToBackend.vue?vue&type=style&index=0&id=207cd685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207cd685",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VCol,VContainer,VFileInput,VIcon,VProgressLinear,VRow,VSelect,VTextField,VTextarea})
